import {Provider} from "react-redux";
import configure from "../../../store/configure";
import Layout from "../../../component/layout/Layout";
import InquiryCreateContainer from "../container/InquiryCreateContainer";
import React from "react";

const InquiryCreatePage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <InquiryCreateContainer />
            </Layout>
        </Provider>
    );
};

export default InquiryCreatePage;